module.exports = __webpack_public_path__ + "static/casa4-aeba1620cd1acbc98589b68c18ab0bf4.png";